import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import PartDetailsMobile from './PartDetailsMobile';
import { IWarrantyProvider } from 'src/model/warranty.model';
import {
  warrantyProvidersSel,
  warrantyActions
} from 'src/store/modules/warranty';

interface IStateFromProps {
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  warranties: IWarrantyProvider[];
}

interface IDispatchFromProps {
  getWarranties: () => void;
}

const mapStateToProps = (state: any) => ({
  showOnlyMSRP: state.msrp.showOnlyMSRP,
  isLoggedIn: state.signin.success,
  warranties: warrantyProvidersSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getWarranties: () => dispatch(warrantyActions.getWarranty())
});

export const pureComponent = PartDetailsMobile;
export default connect<IStateFromProps, IDispatchFromProps, void>(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(PartDetailsMobile));
